// UQ-en-CA
module.exports = {
  "forTest": "test for UQ-en-CA",
  "text_styling_book_header_title": "STYLING BOOK",
  "text_styling_book_official_styling": "Official Styling",
  "text_styling_book_stylehint": "StyleHint",
  "text_sort": "Sort by",
  "text_filter": "Filter",
  "text_styling_book_search_results_number": "{total} result(s)",
  "text_active_filters": "Active Filters",
  "text_styling_book_clear_all_filters": "Clear all",
  "text_styling_book_search_by_feature": "Search by collection",
  "text_styling_book_search_by_category": "Search by category",
  "text_styling_book_staff_customer_filter_all": "All",
  "text_styling_book_search_by_coordinate": "Search by keyword",
  "text_styling_book_staff_customer_filter_title": "Posted by",
  "text_styling_book_search_by_height": "Search by height",
  "text_styling_book_search_by_hashtag": "Search by hashtag",
  "text_styling_book_staff_customer_filter_customer_styling": "Customers",
  "text_styling_book_staff_customer_filter_staff_styling": "UNIQLO Staff",
  "text_apply_search_filter": "Apply",
  "text_styling_book_no_results": "No results",
  "text_error_title": "Service temporarily unavailable",
  "text_503_error_description-1": "Our apologies, there has been an error.",
  "text_503_error_description-2": "Please try again later or go back to the previous page using your browser's back button.",
  "text_503_error_instruction": "If you have any questions, please go to our CONTACT US page.",
  "text_styling_book_go_to_top": "UNIQLO home",
  "text_contactus": "Contact us",
  "text_wishlist": "Wishlist",
  "text_membership_info": "Membership",
  "text_wearing_items": "Styled items",
  "text_color": "Colour",
  "text_size": "Size",
  "text_stylehint_non_listed_items_message_01": "*Products not displayed are unavailable.",
  "text_styling_book_related_styling_title": "You may also like",
  "text_style_styling_date_update": "Update",
  "text_styling_book_hashtag_title": "Hashtag",
  "currency_format": "CAD $ {price}",
  "text_404": "Page not found",
  "text_official_styling_top_page_link": "Official styling top page",
  "text_stylehint_top_page_link": "StyleHint top page",
  "text_breadcrumbs_top": "UNIQLO",
  "text_a11y_close": "Close",
  "text_log_in": "Log in",
  "text_app_update_dialog_cancel": "Cancel",
  "text_menu": "Menu",
  "text_copyright": "Copyright © UNIQLO Co., Ltd. All rights reserved.",
  "text_stylehintapp": "StyleHint App",
  "text_styling_book_official_styling_page_title": "Official Styling",
  "text_styling_book_stylehint_page_title": "StyleHint",
  "text_styling_book_sort_latest": "New arrivals",
  "text_styling_book_sort_popular": "Most popular",
  "text_styling_book_search_by_color": "Search by colour",
  "text_filter_clear_all_category": "Clear all categories",
  "text_styling_book_filter_height_over": "≧",
  "text_styling_book_filter_height_under": "≦",
  "text_show_all": "Show all",
  "text_error_description": "There has been a system error. Please try again or come back later.",
  "text_system_error": "System error",
  "text_ok": "OK",
  "text_login_required": "Login required",
  "text_login_request": "Please go to the login page.",
  "text_error_failed_sort_product": "Failed to find products with your selected criteria. Please try a different search.",
  "text_error_failed_update_filter_criteria": "Failed to update the filter criteria. Please try again.",
  "text_meta_title_postfix": "| UNIQLO CA",
  "text_meta_title_prefix": "UNIQLO |",
  "text_styling_book_meta_title_brand": "UNIQLO",
  "text_styling_book_meta_women": "Women",
  "text_styling_book_meta_men": "Men",
  "text_styling_book_meta_kids": "Kids",
  "text_styling_book_meta_baby": "Baby",
  "text_styling_book_official_gender_meta_description": "Explore our lookbook and find the perfect {gender} styles of the season! Shop the whole look or add your favorites to your wishlist to shop later.",
  "text_styling_book_official_gender_meta_title": "Explore seasonal looks | {gender} | Official Styling {uqPostfix}",
  "text_styling_book_official_gender_filter_meta_title": "{gender}'s 「{filterOptions}」styling ideas {uqPostfix}",
  "text_styling_book_official_gender_filter_meta_description": "Learn {gender}'s 「{filterOptions}」styling ideas with fashion items from {brand}. Check out how to style with products on trend.",
  "text_styling_book_official_detail_meta_title": "Shop looks for「{officialProducts}」{uqPostfix}",
  "text_styling_book_official_detail_meta_description": "Check out fresh seasonal styles for「{officialProducts}」and shop the whole look at {brand}.com now!",
  "text_styling_book_stylehint_gender_meta_title": "Find new styling ideas | {gender} | StyleHint {uqPostfix}",
  "text_styling_book_stylehint_gender_meta_description": "Get inspired! Browse {gender} styling ideas from our customers and {brand} Staff posted via StyleHint app.",
  "text_styling_book_stylehint_filter_meta_title": "{gender}'s 「{filterOptions}」styling ideas {uqPostfix}",
  "text_styling_book_stylehint_store_user_meta_title": "Outfit ideas of {userName}({storeName}) {uqPostfix}",
  "text_styling_book_stylehint_ins_user_meta_title": "Outfit ideas of {userName} {uqPostfix}",
  "text_styling_book_stylehint_customer_user_meta_title": "Outfit ideas of {userName}({height}) {uqPostfix}",
  "text_styling_book_stylehint_detail_meta_title": "Check styling ideas for「{stylehintProducts}」{uqPostfix}",
  "text_styling_book_stylehint_store_user_meta_description": "Learn {brand}({storeName})'s staff {staffName}({height}) outfit ideas. Check out how the staff style with products on trend.",
  "text_styling_book_stylehint_ins_user_meta_description": "Learn Instagram user 「{userName}」outfit ideas using {brand} fashion items to mix-and-match the outfit. Check out other users and see how they style with products on trend.",
  "text_styling_book_stylehint_customer_user_meta_description": "Learn {userName} ({height})'s outfit ideas using {brand} products to stay in fashion. Check out the items worn by models at the online store.",
  "text_styling_book_stylehint_detail_meta_description": "Discover fresh styles for「{stylehintProducts}」from our customers and {brand} Staff. Shop the whole look at {brand}.com now!",
  "text_styling_book_stylehint_filter_meta_description": "Learn 「{searchCount}」outfit ideas of「{filterOptions}」 using {brand} fashion items. Check out the new arrivals & trend items at the online store.",
  "text_styling_book_stylehint_styling_id_alt_tag": "{brand} STYLING BOOK outfit ideas Style ID: <{styleId}>",
  "text_styling_book_official_styling_id_alt_tag": "{brand} STYLING BOOK styling ideas Style ID: <{styleId}>",
  "text_styling_book_official_detail_id_alt_tag": "Find out styling ideas of「{officialProducts}」",
  "text_styling_book_stylehint_detail_id_alt_tag": "Find out the outfit ideas of「{stylehintProducts}」",
  "text_styling_book_product_id_alt_tag": "{productName} {gender}",
  "text_styling_book_stylehint_user_id_alt_tag": "{userName}",
  "text_styling_book_stylehint_hashtag_alt_tag": "Outfit ideas of {gender}'s「{hashtag}」",
  "text_styling_book_stylehint_feature_alt_tag": "Styling ideas of {gender}'s 「{feature}」",
  "text_style_model_height": "",
  "text_503_error_description": "Our apologies. There has been an error. Please access to this site later or go back to the previous page using the browser back button.",
  "text_styling_book_meta_official_styling": "styling ideas",
  "text_styling_book_meta_stylehint": "outfit ideas",
  "text_limited_offer_until_date": "{flagName} until {date}",
  "text_online_store_exclusive_limited_offer_until_date": "{flagName} until {date}",
  "text_app_membership_exclusive_limited_offer_until": "{flagName} until {date}",
  "text_csoon_early": "Available early {month}",
  "text_csoon_mid": "Available Mid-{month}",
  "text_csoon_late": "Available late {month}",
  "text_men": "MEN",
  "text_women": "WOMEN",
  "text_kids": "KIDS",
  "text_baby": "BABY",
  "text_unisex": "UNISEX",
  "text_app_membership_exclusive_limited_offer": "App Members-Only Offer",
  "text_styling_book_gender_menu_kids_and_baby": "Kids & Baby",
  "text_styling_book_meta_kids_and_baby": "KIDS・BABY",
  "text_a11y_favorites_add": "Add to wish list",
  "text_close": "Close",
  "text_error_wishlist_max": "You have reached the max of 999 items. Please edit your wish list to add this item.",
  "text_size_multiplication_sign": "✕",
  "text_no_image": "No image",
  "text_wearing_size_code01": "Wearing size: {size_code}",
  "text_locale_hk_zh": "",
  "text_locale_en": "English",
  "text_locale_fr": "Français",
  "text_locale_th": "",
  "text_locale_id": "",
  "text_locale_vi": "",
  "text_locale_de": "",
  "text_locale_es": "",
  "text_locale_it": "",
  "text_locale_nl": "",
  "text_product_unavailable": "This product has been discontinued.",
  "text_product_display_markdown": "",
  "text_color_white": "White",
  "text_color_gray": "Gray",
  "text_color_black": "Black",
  "text_color_pink": "Pink",
  "text_color_red": "Red",
  "text_color_orange": "Orange",
  "text_color_beige": "Beige",
  "text_color_brown": "Brown",
  "text_color_yellow": "Yellow",
  "text_color_green": "Green",
  "text_color_blue": "Blue",
  "text_color_purple": "Purple",
  "text_promotion": "Promotion",
  "text_styling_promotion_hashtag": "Promotion",
  "text_coming_soon": "Coming soon",
  "text_markdown": "Sale",
  "text_multibuy_markdown": "Multibuy, markdown",
  "text_multibuy_limited_offer_until_date": "Multibuy, limited-time offer until {date}",
  "text_app_membership_exclusive_multi_buy_until": "Multibuy Online + App-Only Offer until {date}",
  "text_app_membership_exclusive_multi_buy": "Multibuy Online + App-Only Offer",
  "text_app_membership_exclusive_limitedoffers_until": "Online + App-Only Offer until {date}",
  "text_item_preorder_color_size_only": "Pre-order (some colours / sizes)",
  "text_item_resale_color_size_only": "Back in stock (some colours / sizes)"
}; // generated at Fri May 30 2025 10:40:10 GMT+0800 (Hong Kong Standard Time)